import React, { useState, useRef, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../store/authSlice";
import { KeyIcon } from "@heroicons/react/24/outline";
import { companyLogo, companyName } from "../config";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isAuthenticated } = useSelector((state) => state.auth);
  const userInfoString = localStorage.getItem("userInfo");
  const userInfo = userInfoString ? JSON.parse(userInfoString) : {};

  const navLinkClass = ({ isActive }) =>
    `text-white text-sm font-medium hover:text-blue-200 transition-colors duration-300`;

  const handleLogout = async () => {
    localStorage.clear();
    try {
      await dispatch(logout());
      navigate("/login");
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const changePassword = () => {
    setIsDropdownOpen(false);
    navigate("/change-password");
  };

  return (
<header className="w-full bg-gradient-to-r from-green-700 via-green-600 to-green-500 shadow-md px-4 md:px-8">
<div className="container mx-auto py-3 px-4 sm:px-6">
        <div className="flex justify-between items-center">
          {/* Logo and Title */}
          <div className="flex items-center space-x-2">
            <NavLink to="/">
              <span className="text-white text-3xl sm:text-2xl font-extrabold tracking-tight hover:text-blue-200 transition-colors duration-300">
                {companyName}
              </span>
            </NavLink>
          </div>

          <div className="flex items-center justify-end flex-grow">
            {/* Desktop Navigation */}
            <nav className="hidden md:flex items-center gap-8">
              {!isAuthenticated && (
                <>
                  <NavLink to="/" className={navLinkClass}>
                    Home
                  </NavLink>
                  <NavLink to="/new-applicant-list" className={navLinkClass}>
                    Apply Now
                  </NavLink>
                </>
              )}

              {isAuthenticated && (
                <div className="relative" ref={dropdownRef}>
                  <button
                    onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                    className="flex items-center space-x-2 text-white hover:text-blue-200"
                    aria-haspopup="true"
                    aria-expanded={isDropdownOpen}
                    aria-label="User menu"
                  >
                    <div className="w-10 h-10 rounded-full bg-green-600 flex items-center justify-center text-white font-semibold text-lg hover:bg-green-700 transition-colors duration-200">
                      {companyLogo ? (
                        <img
                          src={companyLogo}
                          alt="Logo"
                          className="w-full h-full rounded-full"
                        />
                      ) : (
                        userInfo.username?.substring(0, 2).toUpperCase() || "AD"
                      )}
                    </div>
                  </button>

                  {isDropdownOpen && (
                    <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg py-2 z-50">
                      <div className="px-4 py-2 border-b border-gray-200">
                        <p className="text-sm font-semibold text-gray-900">
                          {userInfo?.username || "Student"}
                        </p>
                        <p className="text-xs text-gray-500">{userInfo?.email || ""}</p>
                        <div className="mt-1 flex flex-wrap gap-1">
                          {userInfo?.roles?.map((role, index) => (
                            <span
                              key={index}
                              className="inline-block px-2 py-0.5 text-xs font-medium bg-blue-100 text-blue-800 rounded-full"
                            >
                              {role}
                            </span>
                          ))}
                        </div>
                      </div>

                      <button
                        onClick={changePassword}
                        className="w-full flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded-lg transition-colors"
                      >
                        <KeyIcon className="h-5 w-5 mr-3 rotate-90" />
                        Change Password
                      </button>
                      <button
                        onClick={() => {
                          setIsDropdownOpen(false);
                          handleLogout();
                        }}
                        className="w-full text-left px-4 py-2 text-gray-700 hover:bg-blue-50 rounded-lg"
                      >
                        Sign out
                      </button>
                    </div>
                  )}
                </div>
              )}

              {!isAuthenticated && (
                <NavLink to="/login" onClick={() => setIsDropdownOpen(false)}>
                  <button className="text-green-800 border border-green-800 bg-transparent px-6 py-2 rounded-full font-semibold hover:bg-green-100 transition-all duration-300 transform hover:scale-105 shadow-md">
                    Login
                  </button>
                </NavLink>
              )}
            </nav>
          </div>

      
      
        </div>


      </div>
    </header>
  );
};

export default Header;
